/**
 * Ponto único para paths base do host.
 * Troque aqui ao trocar de produto.
 */
export const APP_DEFAULT_INTERNAL_PATH = 'experiments';
